var e={name:"rz-popup",props:{title:{type:String,default:""},left:{type:Boolean,default:!1}}};export{e as default};
